<template>
  <div class="app-container">
    <el-form ref="form" :model="form" label-width="120px" class="el-form-title">
      <el-form-item label="模板名称">
        <el-input v-model="form.name" placeholder="请输入需要查询的模板名称" />
        <el-button @click="fetchData">查询</el-button>
        <el-button type="primary" @click="showAddDialog">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      height="calc(100vh - 200px)"
      border=""
      :header-cell-style="{background:'rgb(244 244 244)'}"
      :empty-text="'暂无数据'"
    >
      <el-table-column align="center" label="模板名称" min-width="180" fixed="left">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="描述" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.description || '暂无' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="550" fixed="right">
        <template slot-scope="scope">
          <el-button @click="editQuestionPrompt(scope.row)">出题提示词</el-button>
          <el-button @click="editTipPrompt(scope.row)">提示提示词</el-button>
          <el-button @click="editScoreRule(scope.row)">评分规则</el-button>
          <el-button @click="editCreatePrompt(scope.row)">创建提示词</el-button>
          <el-button @click="delItem(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增模板弹窗 -->
    <el-dialog title="新增模板" :visible.sync="addDialogVisible" width="600px" top="15%">
      <el-form ref="addForm" :model="addForm" label-width="120px">
        <el-form-item label="模板名称" required>
          <el-input v-model="addForm.name" placeholder="请输入模板名称" />
        </el-form-item>
        <el-form-item label="模板描述">
          <el-input v-model="addForm.description" type="textarea" placeholder="请输入模板描述" :rows="3" />
        </el-form-item>
        <el-form-item label="结束语句">
          <el-input v-model="addForm.closingRemark" placeholder="请输入结束语句" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAdd">确定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑创建提示词弹窗 -->
    <el-dialog title="编辑创建提示词" :visible.sync="createPromptDialogVisible" width="800px" height="600px" top="8%">
      <el-form ref="createPromptForm" :model="createPromptForm" label-width="120px">
        <el-form-item label="创建提示词">
          <el-input v-model="createPromptForm.createPrompt" type="textarea" placeholder="请输入创建提示词" :rows="15" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createPromptDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmCreatePrompt">确定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑出题提示词弹窗 -->
    <el-dialog title="编辑出题提示词" :visible.sync="questionPromptDialogVisible" width="800px" height="800px" top="2%">
      <el-form ref="questionPromptForm" :model="questionPromptForm" label-width="120px">
        <el-form-item label="出题提示词">
          <el-input v-model="questionPromptForm.questionPrompt" type="textarea" placeholder="请输入出题提示词" :rows="20" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="questionPromptDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmQuestionPrompt">确定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑提示提示词弹窗 -->
    <el-dialog title="编辑提示提示词" :visible.sync="tipPromptDialogVisible" width="800px" height="800px" top="2%">
      <el-form ref="tipPromptForm" :model="tipPromptForm" label-width="120px">
        <el-form-item label="提示提示词">
          <el-input v-model="tipPromptForm.tipPrompt" type="textarea" placeholder="请输入提示提示词" :rows="20" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tipPromptDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmTipPrompt">确定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑评分规则弹窗 -->
    <el-dialog title="编辑评分规则" :visible.sync="scoreRuleDialogVisible" width="800px" height="600px" top="8%">
      <el-form ref="scoreRuleForm" :model="scoreRuleForm" label-width="120px">
        <el-form-item label="评分规则">
          <el-input v-model="scoreRuleForm.scoreRule" type="textarea" placeholder="请输入评分规则" :rows="15" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="scoreRuleDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmScoreRule">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { templateList, templateAdd, templateUpdate, templateDel } from '@/api/exercise'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      list: [],
      listLoading: false,
      addDialogVisible: false,
      questionPromptDialogVisible: false,
      tipPromptDialogVisible: false,
      scoreRuleDialogVisible: false,
      createPromptDialogVisible: false,
      form: {
        name: ''
      },
      addForm: {
        name: '',
        description: '',
        closingRemark: '',
        createPrompt: ''
      },
      questionPromptForm: {
        id: '',
        questionPrompt: ''
      },
      tipPromptForm: {
        id: '',
        tipPrompt: ''
      },
      scoreRuleForm: {
        id: '',
        scoreRule: ''
      },
      createPromptForm: {
        id: '',
        createPrompt: ''
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.listLoading = true
      const params = {
        page: 1,
        pageSize: 10,
        name: this.form.name
      }
      templateList(params).then(response => {
        const records = response.data.records || []
        records.forEach(res => {
          res.createTime = dayjs(res.createTime).format('YYYY-MM-DD HH:mm:ss')
        })
        this.list = records
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    showAddDialog() {
      this.addForm = {
        name: '',
        description: '',
        closingRemark: '',
        createPrompt: ''
      }
      this.addDialogVisible = true
    },
    confirmAdd() {
      if (!this.addForm.name) {
        this.$message({
          message: '请输入模板名称',
          type: 'error',
          duration: 2 * 1000
        })
        return
      }
      templateAdd(this.addForm).then(() => {
        this.$message({
          type: 'success',
          message: '新增成功',
          duration: 2 * 1000
        })
        this.addDialogVisible = false
        this.fetchData()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '新增失败',
          duration: 2 * 1000
        })
      })
    },
    editQuestionPrompt(row) {
      this.questionPromptForm = {
        id: row.id,
        questionPrompt: row.questionPrompt || ''
      }
      this.questionPromptDialogVisible = true
    },
    confirmQuestionPrompt() {
      templateUpdate({
        id: this.questionPromptForm.id,
        questionPrompt: this.questionPromptForm.questionPrompt
      }).then(() => {
        this.$message({
          type: 'success',
          message: '更新成功',
          duration: 2 * 1000
        })
        this.questionPromptDialogVisible = false
        this.fetchData()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '更新失败',
          duration: 2 * 1000
        })
      })
    },
    editTipPrompt(row) {
      this.tipPromptForm = {
        id: row.id,
        tipPrompt: row.tipPrompt || ''
      }
      this.tipPromptDialogVisible = true
    },
    confirmTipPrompt() {
      templateUpdate({
        id: this.tipPromptForm.id,
        tipPrompt: this.tipPromptForm.tipPrompt
      }).then(() => {
        this.$message({
          type: 'success',
          message: '更新成功',
          duration: 2 * 1000
        })
        this.tipPromptDialogVisible = false
        this.fetchData()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '更新失败',
          duration: 2 * 1000
        })
      })
    },
    editScoreRule(row) {
      this.scoreRuleForm = {
        id: row.id,
        scoreRule: row.scoreRule || ''
      }
      this.scoreRuleDialogVisible = true
    },
    confirmScoreRule() {
      templateUpdate({
        id: this.scoreRuleForm.id,
        scoreRule: this.scoreRuleForm.scoreRule
      }).then(() => {
        this.$message({
          type: 'success',
          message: '更新成功',
          duration: 2 * 1000
        })
        this.scoreRuleDialogVisible = false
        this.fetchData()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '更新失败',
          duration: 2 * 1000
        })
      })
    },
    editCreatePrompt(row) {
      this.createPromptForm = {
        id: row.id,
        createPrompt: row.createPrompt || ''
      }
      this.createPromptDialogVisible = true
    },
    confirmCreatePrompt() {
      templateUpdate({
        id: this.createPromptForm.id,
        createPrompt: this.createPromptForm.createPrompt
      }).then(() => {
        this.$message({
          type: 'success',
          message: '更新成功',
          duration: 2 * 1000
        })
        this.createPromptDialogVisible = false
        this.fetchData()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '更新失败',
          duration: 2 * 1000
        })
      })
    },
    delItem(id) {
      this.$confirm('此操作将删除该模板, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        templateDel({ id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功',
            duration: 2 * 1000
          })
          this.fetchData()
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '删除失败',
            duration: 2 * 1000
          })
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep{
  .el-table{
    overflow: auto;
  }
  .el-button {
    margin-left: 0;
    padding: 10px 18px;
    margin-right: 20px;
    &:focus, &:hover{
      background: #FFF;
      border: 1px solid #DCDFE6;
      color: #606266;
    }
  }
  .el-button:last-child{
    margin-right: 0;
    color: #FFF;
    background-color: #409EFF;
  }
}
.el-form-title{
  ::v-deep{
    .el-form-item__content{
      display: flex !important;
    }
    .el-input {
      width: 300px;
    }
    .el-button {
      margin-left: 20px;
    }
  }
}
</style>
